import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from 'app/App';
import 'react-datepicker/dist/react-datepicker.css';
import LocalStorage from 'services/local-storage';

import { createStandaloneToast } from '@chakra-ui/react';
export const { ToastContainer, toast } = createStandaloneToast();

// Validate local storage before running the app in case of a breaking change in formats
LocalStorage.validate(() => {
    const container = document.getElementById('root');
    const root = createRoot(container!);
    root.render(
        <React.StrictMode>
            <App />
            <ToastContainer />
        </React.StrictMode>
    );
});
